import {
  InvoicePaymentMention,
  QuotePaymentMention,
} from '@shinetools/invoicing-rules';
import LocalizedStrings from 'localized-strings';

import { SupportedLanguages } from 'common/locale';
import { formatDate } from 'helpers/date';

interface InvoicingData {
  startAt: number;
  lateFeePercentage: number;
  lateMaxDays: number;
}

type PaymentMentionType = InvoicePaymentMention | QuotePaymentMention;

interface PaymentMentionLocale<T> {
  type: T;
  valueEn: string;
  valueFr: string;
}

interface Company {
  tradeName: string | null;
  legalName: string;
}

export const populateLocaleValues = <T extends PaymentMentionType>(
  company: Company,
  data: InvoicingData,
  paymentMention: PaymentMentionLocale<T>,
): PaymentMentionLocale<T> => {
  const localizedStrings = new LocalizedStrings({
    en: {
      paymentMention: paymentMention.valueEn,
    },
    fr: {
      paymentMention: paymentMention.valueFr,
    },
  });
  const getFormattingArgs = (lang: SupportedLanguages) => ({
    companyName: company.tradeName || company.legalName,
    lateFeePercentage: data.lateFeePercentage,
    lateMaxDays: data.lateMaxDays,
    startAt: formatDate(new Date(data.startAt), 'PP', lang),
  });

  return {
    type: paymentMention.type,
    valueEn: localizedStrings.formatString(
      paymentMention.valueEn,
      getFormattingArgs('en'),
    ),
    valueFr: localizedStrings.formatString(
      paymentMention.valueFr,
      getFormattingArgs('fr'),
    ),
  };
};
